import React /*, { useState } */ from "react";
import { useNavigate } from "react-router-dom";

import "./SideBar.css";

const SideBar = () => {
	const redirect = useNavigate();

	const handleHomeRedirect = () => {
		redirect("/");
	};
	return (
		<div className="sidebar">
			<div className="qflo-logo-sidebar">
				<img
					className=""
					alt="logo"
					src="/media/icons/logoV2.png"
					onClick={() => handleHomeRedirect()}
					style={{ cursor: "pointer" }}
				/>
				<img
					className=""
					alt="logo"
					src="/media/icons/lineImg.png"
				/>
			</div>
		</div>
	);
};

export default SideBar;
